import { Menu, Dropdown, Checkbox, Button, Divider, Input } from 'antd';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
// import { useRouterTarget } from '&/utils/customHooks';

import './index.scss';

const PhotoAlbumBar = forwardRef((props, ref) => {
    const {
        onAllSelectChange = () => {},
        onIsShowOperateBtnChange = () => {},
        onSearch = () => {},
        onOrder = () => {},
        onCheckBoxChange = () => {},
        setList = () => {},
        list,
        onMultiDelete = () => {},
        onMultiMove = () => {},
        onMultiUpShelf = () => {},
        onMultiDownShelf = () => {},
        showDelete = true,
    } = props;

    const typeList = [
        { order: '0', name: '按创建时间倒序' },
        { order: '1', name: '按创建时间正序' },
    ];

    // const targetPage = useRouterTarget();

    const [typeItem, setTypeItem] = useState(typeList[0]);

    const onTypeClick = ({ key }) => {
        const selected = typeList.find(item => +item.order === +key);
        setTypeItem(selected);
        onOrder(key);
    };

    const typeMenu = (
        <Menu onClick={onTypeClick} selectedKeys={typeItem?.order}>
            {typeList.map(item => (
                <Menu.Item key={item.order}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const [isShowOperateBtn, setIsShowOperateBtn] = useState(false);
    const [selectedAll, setSelectedAll] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [isApproval, setIsApproval] = useState(false);
    const onChange = e => {
        setSelectedAll(e.target.checked);

        setIndeterminate(false);

        onAllSelectChange(e.target.checked);

        setList(list =>
            list.map(item => ({ ...item, selectedAll: e.target.checked }))
        );
    };

    useEffect(() => {
        onIsShowOperateBtnChange(isShowOperateBtn);
    }, [isShowOperateBtn]);

    const onApprovalChange = e => {
        setIsApproval(e.target.checked);
        onCheckBoxChange(e.target.checked ? 0 : undefined);
    };

    useImperativeHandle(ref, () => {
        // 需要将暴露的接口返回出去
        return {
            setIsShowOperateBtn: setIsShowOperateBtn,
            setSelectedAll: setSelectedAll,
            isShowOperateBtn: isShowOperateBtn,
            setIndeterminate: setIndeterminate,
            // spaceItem,
            // resolutionItem,
        };
    });

    const onClickSearch = () => {
        onSearch(searchValue);
    };

    const onSearchChange = e => {
        setSearchValue(e.target.value);
        if (!e.target.value) {
            onSearch(e.target.value);
        }
    };

    const suffix = <SearchOutlined onClick={onClickSearch} />;

    const isDisabled = list?.filter(item => item.selectedAll).length === 0;

    // 获取选中的待上架项目（store为0的项目）
    const selectedPendingItems =
        list?.filter(item => item.selectedAll && +item.store === 0) || [];
    // 获取选中的已上架项目（store为1的项目）
    const selectedOnShelfItems =
        list?.filter(item => item.selectedAll && +item.store === 1) || [];

    const isUpShelfDisabled = selectedPendingItems.length === 0;
    const isDownShelfDisabled = selectedOnShelfItems.length === 0;

    const handleMultiUpShelf = () => {
        const ids = selectedPendingItems.map(item => item.id);
        onMultiUpShelf(ids);
    };

    const handleMultiDownShelf = () => {
        const ids = selectedOnShelfItems.map(item => item.id);
        onMultiDownShelf(ids);
    };

    return (
        <div className="ceiling-bar">
            <div className="header-title">
                <div className="dropdown-wrap">
                    <Dropdown
                        overlay={typeMenu}
                        overlayClassName="hdd-dropdown-menu ceiling-bar-dropdown"
                        trigger={['click']}>
                        <span className="space">
                            {typeItem.name}
                            <DownOutlined />
                        </span>
                    </Dropdown>
                </div>
                <div className="right-operate">
                    <Checkbox onChange={onApprovalChange} checked={isApproval}>
                        待上架
                    </Checkbox>
                    <Input
                        placeholder="搜索"
                        className="search"
                        suffix={suffix}
                        allowClear
                        value={searchValue}
                        onPressEnter={onClickSearch}
                        onChange={onSearchChange}
                    />

                    <Divider type="vertical" />

                    {isShowOperateBtn ? (
                        <>
                            <Checkbox
                                onChange={onChange}
                                indeterminate={indeterminate}
                                checked={selectedAll}>
                                全选 | 已选
                                {list?.filter(item => item.selectedAll).length}
                                个
                            </Checkbox>

                            <Button
                                className="download"
                                onClick={handleMultiUpShelf}
                                disabled={isUpShelfDisabled}>
                                上架
                            </Button>

                            <Button
                                className="download"
                                onClick={handleMultiDownShelf}
                                disabled={isDownShelfDisabled}>
                                下架
                            </Button>

                            <Button
                                className="download"
                                onClick={onMultiMove}
                                disabled={isDisabled}>
                                移动
                            </Button>

                            {showDelete && (
                                <Button
                                    className="delete"
                                    onClick={onMultiDelete}
                                    disabled={isDisabled}>
                                    删除
                                </Button>
                            )}

                            <Button
                                className="download"
                                onClick={() => setIsShowOperateBtn(false)}>
                                取消
                            </Button>
                        </>
                    ) : (
                        <Button
                            className="delete"
                            onClick={() => setIsShowOperateBtn(true)}>
                            批量操作
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
});

export default PhotoAlbumBar;
